export const ratingColors = ['#EF6E4A', '#FBAF48', '#F5D14D', '#AEE778', '#6BD68D'];

export const humboOgImageUrl = 'https://humbo.s3.eu-north-1.amazonaws.com/website/humboOg.png';

export const humboUserId = '6043c0c561cc36001529872d';

export const authCookieName = 'humbo-auth';
